import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface ToolCardProps {
  title: string;
  imageSrc: string;
  link: string;
}

const ToolCard: React.FC<ToolCardProps> = ({ title, imageSrc, link }) => {
  const navigate = useNavigate();
  return (
    <div
      className="bg-background mb-2 p-6 cursor-pointer w-full max-w-[380px] h-[369px] rounded-xl"
      onClick={() => navigate(link)}
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-xl font-semibold text-text-primary">{title}</h2>
        <ArrowRight className="w-5 h-5 text-primary cursor-pointer" />
      </div>
      <div className="rounded-lg overflow-hidden w-full h-[264px] aspect-video">
        <img
          src={imageSrc}
          alt={title}
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

const TrendingTools = () => {
  const tools = [
    {
      title: 'Blog Writer',
      imageSrc: '/trending1.png',
      link: '/ai-blog-writer/get-started',
    },
    {
      title: 'Podcast Generator',
      imageSrc: '/trending2.png',
      link: '/ai-podcast-generator/get-started',
    },
    {
      title: 'Social Media Generator',
      imageSrc: '/trending3.png',
      link: '/social-media/get-started',
    },
  ];

  return (
    <div className="w-full max-w-[1800px] pb-9 pt-8 rounded-lg bg-background-main mx-auto px-4">
      <h1 className="text-[17px] text-text-primary lg:text-3xl text-left font-bold mb-8">
        Check some of our trending tools out!
      </h1>
      <div className="flex flex-col items-center lg:flex-row gap-8 justify-center">
        {tools.map((tool, index) => (
          <ToolCard
            key={index}
            link={tool.link}
            title={tool.title}
            imageSrc={tool.imageSrc}
          />
        ))}
      </div>
    </div>
  );
};

export default TrendingTools;
